import { Component, ViewEncapsulation } from '@angular/core';
import { NgbDropdown, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { merge, Observable } from 'rxjs';
import { ToastNotificationService } from '../core/toast-notification.service';
import { UIBlockingService } from '../core/ui-blocking.service';
import { DumbMemberDiscount } from '../public-portal/member-information/DTOs/dumb-member-discount';
import { AddEditChamberPerkModalComponent } from './add-edit-chamber-perk-modal.component';
import { DiscountsDtRetInfo } from './DTOs/discounts-dt-ret-info';
import { GetDiscountListRequest } from './DTOs/get-discount-list-request';
import { SuperAdminMemberManagementService } from './super-admin-member-management.service';

@Component({
  selector: 'app-super-admin-chamber-perk-management',
  templateUrl: './super-admin-chamber-perk-management.component.html',
  providers: [UIBlockingService, NgbDropdown],
  encapsulation: ViewEncapsulation.None
})
export class SuperAdminChamberPerkManagementComponent {
  constructor(private superAdminMemberManagementService: SuperAdminMemberManagementService
    , private blockUI: UIBlockingService
    , private notificationService: ToastNotificationService
    , private modalService: NgbModal) {

  }

  discounts: DumbMemberDiscount[] = [];

  totalDiscounts = 0;
  filteredDiscounts = 0;
  pageNum = 1;
  itemsPerPage = 10;
  searchText = "";
  statusSearch = { display: "Active", value: 1 };
  sortType = 1;
  keywordSearches: string[] = [];
  filtersChanged = true;
  initialLoad = true;

  get currentPageNum() { return this.pageNum };
  set currentPageNum(page: number) {
    this.pageNum = page;
    if (!this.initialLoad)
      this.getDiscounts();
  }
  get itemStart() {
    return ((this.currentPageNum - 1) * this.itemsPerPage) + 1;
  }
  get itemEnd() {
    return ((this.currentPageNum - 1) * this.itemsPerPage) + this.discounts.length;
  }

  ngOnInit() {
    var observablesMerged = merge(this.getDiscountsObservable());
    this.blockUI.start();
    observablesMerged.subscribe(
      {
        next: (data) => {
          this.discounts = data.data;
          this.totalDiscounts = data.recordsTotal;
          this.filteredDiscounts = data.recordsFiltered;
          this.initialLoad = false;
        },
        error: (err) => {
          this.notificationService.error(err.error.message);
          this.blockUI.stop();
          console.log(err)
        },
        complete: () => {
          this.blockUI.stop();
        }
      });
  }

  getDiscountsObservable(): Observable<DiscountsDtRetInfo> {
    var req = this.createSearchRequest();
    return this.superAdminMemberManagementService
      .getDiscountsList(req);
  }

  getDiscounts() {
    this.blockUI.start();

    this.getDiscountsObservable()
      .subscribe(
        {
          next: (data) => {
            this.discounts = data.data;
            this.totalDiscounts = data.recordsTotal;
            this.filteredDiscounts = data.recordsFiltered;
          },
          error: (err) => {
            this.notificationService.error(err.error.message);
            this.blockUI.stop();
            console.log(err)
          },
          complete: () => {
            this.blockUI.stop();
          }
        });
  }

  createSearchRequest(): GetDiscountListRequest {
    var req = new GetDiscountListRequest();

    if (this.filtersChanged)
      this.pageNum = 1;

    req.PageNumber = this.pageNum - 1; //to get the 0-indexed number
    req.ItemsPerPage = this.itemsPerPage;

    req.KeywordSearches = this.keywordSearches;
    req.Sorting = this.sortType;
    req.StatusFilter = this.statusSearch.value;

    this.filtersChanged = false;

    return req;
  }

  enterSearchTerm(event: any) {
    if (event.keyCode != 13)//13 is enter, 32 is space
      return;

      this.searchText.trim().split(' ').forEach((term) => this.keywordSearches.push(term));
    this.searchText = '';
      this.filtersChanged = true;
      this.getDiscounts();
    return;
  }

  removeSearchTerm(term: string) {
    var index = this.keywordSearches.indexOf(term);
    if (index != -1) {
      this.keywordSearches.splice(index, 1);
      this.filtersChanged = true;
      }
      this.getDiscounts();
  }

  changeStatusSearch(toChange: number) {
    if (this.statusSearch.value == toChange)
      return;

    this.filtersChanged = true;
    switch (toChange) {
      case 1:
        this.statusSearch = { display: "Active", value: 1 };
        break;
      case 2:
        this.statusSearch = { display: "Expired", value: 2 };
        break;
      case 3:
        this.statusSearch = { display: "All", value: 3 };
        break;
      default:
        this.statusSearch = { display: "Active", value: 1 };
        break;
      }
      this.getDiscounts();
  }
  clearSearch() {
    this.searchText = "";
    this.statusSearch = { display: "Active", value: 1 };
    this.sortType = 1;
    this.keywordSearches = [];
      this.filtersChanged = true;
    this.getDiscounts()
  }

  hitSearchBtn() {
      console.log("hehe")
    this.searchText.trim().split(' ').forEach((term) => this.keywordSearches.push(term));
    this.searchText = '';
    this.filtersChanged = true;
    this.getDiscounts();
  }

  changeSortType(column: number) {
    switch (column) {
      case 1:
        if (this.sortType == 1)
          this.sortType = 2;
        else this.sortType = 1;
        break;
      case 3:
        if (this.sortType == 3)
          this.sortType = 4;
        else this.sortType = 3;
        break;
      case 5:
        if (this.sortType == 5)
          this.sortType = 6;
        else this.sortType = 5;
        break;
      case 7:
        if (this.sortType == 7)
          this.sortType = 8;
        else this.sortType = 7;
        break;
      default:
        break;
    }
    this.filtersChanged = true;
    this.getDiscounts();
  }

  addPerk() {
    const modalRef = this.modalService.open(AddEditChamberPerkModalComponent, { size: 'lg', backdrop: 'static' });
    modalRef.componentInstance.admin = new DumbMemberDiscount();
    modalRef.componentInstance.headerText = "Add Perk";
    modalRef.componentInstance.adding = true;
    modalRef.result.then(response => {
      this.getDiscounts();
    })
      .catch(err => {

      }).finally();
  }

}
